import React, { useState } from "react";
import VotersChart from "./ActiveVotersChart";

const votersDataByYear = {
  2018: [
    { Fields: "Constitution", "No. of Voters": "5150" },
    { Fields: "Democratic", "No. of Voters": "185664" },
    { Fields: "Green", "No. of Voters": "1632" },
    { Fields: "Independent American", "No. of Voters": "36856" },
    { Fields: "Libertarian", "No. of Voters": "14643" },
    { Fields: "Republican", "No. of Voters": "681382" },
    { Fields: "United Utah", "No. of Voters": "1465" },
    { Fields: "Unaffiliated", "No. of Voters": "511535" },
    { Fields: "Total Active Voters", "No. of Voters": "14,38,053" },
  ],
  2019: [
    { Fields: "Constitution", "No. of Voters": "5428" },
    { Fields: "Democratic", "No. of Voters": "190135" },
    { Fields: "Green", "No. of Voters": "1863" },
    { Fields: "Independent American", "No. of Voters": "50365" },
    { Fields: "Libertarian", "No. of Voters": "19401" },
    { Fields: "Republican", "No. of Voters": "675205" },
    { Fields: "United Utah", "No. of Voters": "1690" },
    { Fields: "Unaffiliated", "No. of Voters": "508131" },
    { Fields: "Total Active Voters", "No. of Voters": "14,52,218" },
  ],
  2020: [
    { Fields: "Constitution", "No. of Voters": "6019" },
    { Fields: "Democratic", "No. of Voters": "253684" },
    { Fields: "Libertarian", "No. of Voters": "19051" },
    { Fields: "Republican", "No. of Voters": "875410" },
    { Fields: "United Utah", "No. of Voters": "2168" },
    { Fields: "Unaffiliated", "No. of Voters": "554766" },
    { Fields: "Total Active Voters", "No. of Voters": "1711095" },
  ],
  2021: [
    { Fields: "Constitution", "No. of Voters": "6259" },
    { Fields: "Democratic", "No. of Voters": "243623" },
    { Fields: "Independent American", "No. of Voters": "59040" },
    { Fields: "Libertarian", "No. of Voters": "19282" },
    { Fields: "Republican", "No. of Voters": "847961" },
    { Fields: "United Utah", "No. of Voters": "2275" },
    { Fields: "Utah Forward", "No. of Voters": "168" },
    { Fields: "Unaffiliated", "No. of Voters": "488868" },
    { Fields: "Total Active Voters", "No. of Voters": "1667308" },
  ],
  2022: [
    { Fields: "Constitution", "No. of Voters": "6590" },
    { Fields: "Democratic", "No. of Voters": "236024" },
    { Fields: "Independent American", "No. of Voters": "64030" },
    { Fields: "Libertarian", "No. of Voters": "20456" },
    { Fields: "Republican", "No. of Voters": "882396" },
    { Fields: "United Utah", "No. of Voters": "2383" },
    { Fields: "Unaffiliated", "No. of Voters": "480008" },
    { Fields: "Total Active Voters", "No. of Voters": "1691887" },
  ],
  2023: [
    { Fields: "Constitution", "No. of Voters": "6690" },
    { Fields: "Democratic", "No. of Voters": "227599" },
    { Fields: "Independent American", "No. of Voters": "66191" },
    { Fields: "Libertarian", "No. of Voters": "20225" },
    { Fields: "No Labels", "No. of Voters": "957" },
    { Fields: "Republican", "No. of Voters": "873920" },
    { Fields: "United Utah", "No. of Voters": "2316" },
    { Fields: "Unaffiliated", "No. of Voters": "473092" },
    { Fields: "Total Active Voters", "No. of Voters": "1670990" },
  ],
  2024: [
    { Fields: "Constitution", "No. of Voters": "6,548" },
    { Fields: "Democratic", "No. of Voters": "243,065" },
    { Fields: "Green", "No. of Voters": "638" },
    { Fields: "Independent American", "No. of Voters": "73557" },
    { Fields: "Libertarian", "No. of Voters": "19032" },
    { Fields: "No Labels", "No. of Voters": "10824" },
    { Fields: "Republican", "No. of Voters": "931528" },
    { Fields: "United Utah", "No. of Voters": "2249" },
    { Fields: "Utah Forward", "No. of Voters": "155" },
    { Fields: "Unaffiliated", "No. of Voters": "471619" },
    { Fields: "Total Active Voters", "No. of Voters": "1759215" },
  ],
  2025: [
    { Fields: "Constitution", "No. of Voters": "6,537" },
    { Fields: "Democratic", "No. of Voters": "2,40,418" },
    { Fields: "Green", "No. of Voters": "746" },
    { Fields: "Independent American", "No. of Voters": "73,890" },
    { Fields: "Libertarian", "No. of Voters": "18,649" },
    { Fields: "No Labels", "No. of Voters": "10,568" },
    { Fields: "Republican", "No. of Voters": "9,25,338" },
    { Fields: "Utah Forward", "No. of Voters": "2,190" },
    { Fields: "Unaffiliated", "No. of Voters": "4,75,881" },
    { Fields: "Total Active Voters", "No. of Voters": "17,54,217" },
  ],
  2026: [
    {
      Fields: "Constitution",
      "No. of Voters": "6,613",
    },
    {
      Fields: "Democratic",
      "No. of Voters": "2,43,897",
    },
    {
      Fields: "Green",
      "No. of Voters": "962",
    },
    {
      Fields: "Independent American",
      "No. of Voters": "75,030",
    },
    {
      Fields: "Libertarian",
      "No. of Voters": "18,297",
    },
    {
      Fields: "Republican",
      "No. of Voters": "9,21,322",
    },
    {
      Fields: "Forward",
      "No. of Voters": "2,211",
    },
    {
      Fields: "Unaffiliated",
      "No. of Voters": "5,00,218",
    },
    {
      Fields: "Total Active Voters",
      "No. of Voters": "17,68,550",
    },
  ],
};

const ActiveVoters = () => {
  const [selectedYear, setSelectedYear] = useState(2026);

  const handleChange = (e) => {
    setSelectedYear(Number(e.target.value));
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "96%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 style={{ color: "#CB0C0C", marginBottom: "20px" }}>
          Active Voters Chart - {selectedYear}
        </h1>

        <select
          value={selectedYear}
          onChange={handleChange}
          style={{
            marginBottom: "20px",
            padding: "10px",
            fontSize: "16px",
            borderRadius: "4px",
          }}
        >
          {Array.from({ length: 9 }, (_, i) => 2018 + i).map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      <div
        style={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <div style={{ width: "100%", minWidth: "600px" }}>
          <VotersChart data={votersDataByYear[selectedYear]} />
        </div>
      </div>
    </div>
  );
};

export default ActiveVoters;
